module.exports = __webpack_public_path__ + "static/media/Oswald-Light.fb3af9a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Oswald-Light.ttf
// module id = ./src/fonts/Oswald-Light.ttf
// module chunks = 2